import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { OrionResourceCardBox } from "@orion/OrionComponents/OrionResourceCardBox";

export const ReviewCardBox = styled(OrionResourceCardBox)(({ theme }) => ({
  width: "100%",
  height: "100%",
  minHeight: 0,
  boxSizing: "border-box",
  padding: `${theme.spacing(7)} ${theme.spacing(5)} ${theme.spacing(0)}`,
}));

export const ResourceCardImageTileFooterStack = styled(Stack)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.tokens.outlines.defaultDividerLight}`,
  padding: `13px ${theme.spacing(5)} ${theme.spacing(3)}`,
}));

/** Quiet media-type marker pinned to the image corner. */
export const MediaTypeBadgeRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(3),
  right: theme.spacing(3),
  display: "inline-flex",
  padding: theme.spacing(1),
  borderRadius: `${theme.shape.borderRadiusMd}px`,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.secondary,
}));

/** Review card footer shell (border + padding + min height for grid alignment). */
export const ReviewCardFooterShell = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.tokens.outlines.defaultDividerLight}`,
  width: "100%",
  flexShrink: 0,
  boxSizing: "border-box",
  minHeight: theme.spacing(12),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
}));

/** Spacer between leading and trailing slots in {@link FooterActionsRow}. */
export const ResourceCardFooterFlexSpacer = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const ResourceCardImageCover = styled("img")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

export const ResourceCardImageRegionRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "regionAspectRatio",
})<{ regionAspectRatio?: string }>(
  ({ theme, regionAspectRatio = "1 / 1" }) => ({
    position: "relative",
    width: "100%",
    aspectRatio: regionAspectRatio,
    backgroundColor: theme.palette.background["paper-elevation-1"],
    overflow: "hidden",
  }),
);
